import DatePickerMixin from '@/mixins/datepicker';
import data from './_data';
import methods from './_methods';

export default {
    name: 'ModalUpdateRd',
    mixins: [DatePickerMixin],
    data,
    methods
};
